<template>
  <div v-loading="loading">
    <!-- 套餐详情 -->
    <el-row type="flex" justify="center">
      <div v-show="step === 1" class="package-wrapper">
        <!-- 订单套餐 -->
        <div class="product-package" >
          <gj-area-title>订单套餐</gj-area-title>
          <div class="product-package--balance">
            订单包余额：
            <span class="product-package--balance-number">{{ this.proInfo.residual }}</span>单
          </div>
          <div class="product-package--content">
            <div class="product-package--content-detail">1. 按订单量进行计算单量（一个订单包含多个商品，仅计算一个单量）</div>
            <div class="product-package--content-detail" style="margin-bottom: 15px;">2. 充值的订单有效期4年（从充值时间开始计算）</div>
          </div>
        </div>
        <div class="package" v-if="proInfo.productPackages.length > 0">
          <div :gutter="10" :style="{display: 'flex', justifyContent: 'left', flexDirection:'row', flexWrap: 'wrap', height:(Math.ceil(proInfo.productPackages.length / 4) * 325) + 'px', padding: '0px 80px',}">
            
              <div v-for="(row, index) in proInfo.productPackages" :key="row.id" :class="['package-type', curPackageType === index ? 'package-type-choose' : '']"
                :style="`backgroundImage: url(${packageImgUrls[index]});`" @click="choosePackage(index)">
                <div v-if="curPackageType === index" class="package-choose--icon">
                  <img src="../../../../assets/images/package/package_choose.png" alt="已选" style="height: 46px;" />
                </div>
                <el-row type="flex" justify="center" align="middle" class="package-type--order">{{row.name | defaultShow }}</el-row>
                <div class="package-type--info">
                  <div class="package-type--price">￥{{ amount(row.priceSum) }}</div>
                  <div class="package-type--detail">
                      <div class="package-type--detail--label">站点</div>
                      <div class="package-type--detail--content">{{row.marketNum <= 0 || row.marketNum === null ? '不限制' : row.marketNum}}</div>
                  </div>
                   <div class="package-type--detail">
                      <div class="package-type--detail--label">账号数</div>
                      <div class="package-type--detail--content">{{row.accountNum <= 0 || row.accountNum === null ? '不限制' : row.accountNum}}</div>
                  </div>
                   <div class="package-type--detail">
                      <div class="package-type--detail--label">积点</div>
                      <div class="package-type--detail--content">{{row.virtualNum <= 0 || row.virtualNum === null ? '不限制' : row.virtualNum}}</div>
                  </div>
                   <div class="package-type--detail">
                      <div class="package-type--detail--label">关怀/站外邮件</div>
                      <div class="package-type--detail--content">{{row.careAndOutEmailNum <= 0 || row.careAndOutEmailNum === null ? '不限制' : row.careAndOutEmailNum}}</div>
                  </div>
                   <div class="package-type--detail">
                      <div class="package-type--detail--label">客服邮件</div>
                      <div class="package-type--detail--content">{{row.cusServiceEmailNum <= 0 || row.cusServiceEmailNum === null ? '不限制' : row.cusServiceEmailNum}}</div>
                  </div>
                </div>
            
            </div>
          </div>
        </div>
        <!-- 工具包 -->
        <div class="product-package" >
          <gj-area-title>工具包</gj-area-title>
          <div class="product-package--balance">关怀/站外邮件数量
            <span style="color: #666666; margin-left: 8px; flex-wrap: wrap;">
              剩余额度：<span class="product-package--balance-number">{{ this.proInfo.emailResidue }}</span>封
            </span>
          </div>
        </div>
        <div class="package" v-if="proInfo.emailPackages.length > 0">
          <div :gutter="10" :style="{display: 'flex', justifyContent: 'left', flexDirection:'row', flexWrap: 'wrap', height:(Math.ceil(proInfo.emailPackages.length / 4) * 145) + 'px', padding: '0px 85px'}">
            <div v-for="(row, index) in proInfo.emailPackages" :class="['mailPackage', emailPackageType === index ? 'mail-type-choose' : '']" :key="row.id" style="position: relative"  @click="chooseMailPackage(index)">
                <div v-if="emailPackageType === index" class="package-choose--icon">
                    <img src="../../../../assets/images/package/package_choose.png" alt="已选" style="height: 46px"/>
                </div>
                <el-badge v-if="(row.isActiveType !== null && row.isActiveType !== 'standard')" :class="['discountLabel', `active-type-${row.isActiveType}`]" >{{ activeTypes[row.isActiveType] }}</el-badge>
                <div class="number-of-packages" style="margin-top:20px;">{{ row.number }}封</div>
                <el-row type="flex" justify="center" align="middle" class="concessional-rate" style="margin-top:8px;">￥{{ amount(row.priceSum) }}
                    <div class="unit-price">{{ row.priceSum/row.number }}/封</div>
                </el-row>
                <span class="original-price" style="margin-top:6px;">原价
                    <del class="original-price-list-price">{{ row.originalPriceSum }}</del>
                </span>
            </div>
          </div>
        </div>
        <!-- 积点 -->
         <div class="product-package" >
          <div class="product-package--balance">积点
            <span style="color: #666666; margin-left: 8px; flex-wrap: wrap;">
              剩余额度：<span class="product-package--balance-number">{{ this.proInfo.currencyResidue }}</span>点
            </span>
          </div>
        </div>
        <div class="package" v-if="proInfo.currencyPackages.length > 0">
          <div  :style="{display: 'flex', justifyContent: 'left', flexDirection:'row', flexWrap: 'wrap', height:(Math.ceil(proInfo.currencyPackages.length / 5) * 115) + 'px',padding: '0 85px',}">
            <div v-for="(row, index) in proInfo.currencyPackages" :class="['currencyPackage', currencyPackageType === index ? 'currency-type-choose' : '']" :key="row.id" style="position: relative"  @click="chooseCurrencyPackage(index)">
                <div v-if="currencyPackageType === index" class="package-choose--icon">
                    <img src="../../../../assets/images/package/package_choose.png" alt="已选" style="height: 46px"/>
                </div>
                <el-badge v-if="(row.isActiveType !== null && row.isActiveType !== 'standard')" :class="['discountLabel', `active-type-${row.isActiveType}`]" >{{ activeTypes[row.isActiveType] }}</el-badge>
                <div class="currency-type-price" style="margin-top:22px;">¥{{ amount(row.priceSum) }}</div>
                <div class="currency-type-number" style="margin-top:6px;">得{{ row.number }}积点</div>
                <div class="currency-type-tips">{{row.showCopy}}</div>
            </div>
          </div>
        </div>
 

        <!-- <div class="custom-package-bottom">
          <el-divider class="divider"></el-divider>
          <span style="font-size: 13px;">
            <gj-checkbox v-model="checked"></gj-checkbox>
            我已阅读并同意<span @click="openTemplateModal" style="color:#0045F0;cursor: pointer;">《积加ERP产品服务协议》</span>
          </span>
          <span>
            <span style="color:#4E5969;font-weight: bold;"></span>
            总计
            <span class="choose-package--detail--total-number">￥{{
              totalAmount === null ? '0.00'
                : amount(totalAmount)
            }}</span>
          </span>
          <gj-button type="primary" size="middle" style="margin:0 25px" @click="pay()">立即付款</gj-button>
        </div> -->

      </div>
      <!-- 订单详情 -->
      <app-package-order v-if="step === 2" class="package-wrapper" :proInfo="proInfo" @return-package="handleReturn">
      </app-package-order>
    </el-row>
  </div>
</template>

<script>
import AppPackageOrder from "./component/package-order.vue";
import { queryProPackageData } from "../../../../api/setting";
import { getPackageQuota } from "../../../../api/personal-center";
import { amount } from "../../../../filters";
import ServiceAgreement from "./modal/service-agreement";
export default {
  name: "app-erp-package",
  components: { AppPackageOrder },
  created() {
    this.queryData();
    this.getPackageQuota();
  },
  data() {
    return {
      step: 1,
      curPackageType: null,   //选中套餐
      emailPackageType: null, //加油包选中
      currencyPackageType: null,  //积点选中
      packageImgUrls: [
        require('../../../../assets/images/package/package_1.png'),
        require('../../../../assets/images/package/package_2.png'),
        require('../../../../assets/images/package/package_3.png'),
        require('../../../../assets/images/package/package_4.png'),
        require('../../../../assets/images/package/package_5.png'),
        require('../../../../assets/images/package/package_1.png'),
        require('../../../../assets/images/package/package_2.png'),
        require('../../../../assets/images/package/package_3.png'),
        require('../../../../assets/images/package/package_4.png'),
        require('../../../../assets/images/package/package_5.png'),
      ],
      proInfo: {
        residual: 0, // 订单包余额
        emailResidue: 0,   //邮件剩余
        currencyResidue: 0,  //积点剩余
        productPackages: [], // 产品套餐
        emailPackages: [],   //加油包
        currencyPackages: [], //积点
        selfDefines: [], // 关怀/站外邮件加油包
        selfDefinesArr: [],
        fixedPackageObj: null,//固定套餐选中对象
        emailPackageObj: null,//加油包选中对象
        currencyPackageObj: null, //积点选中对象
        customObj: null,
        sumFee: 0.00,//总金额
        sumOrder: 0,//总订单
      },
      loading: false,
      amount: amount,
      checked: false,
      input: "",
      packageQuota: {},   //套餐额度
      fuelPack: 0,
      totalNum: 0,
      activeTypes:{
        firstcharge: '首充优惠',
        specialoffer: '超值',
        preferentialprice: '优惠价',
        costperformance: '性价比最高',
        standard: '',
      }
      

      
    }
  },
  computed: {
    totalAmount() {
      let amount = this.proInfo.fixedPackageObj !== null ? this.proInfo.fixedPackageObj.priceSum : 0.00;   //固定套餐金额
      let emailPrice = this.proInfo.emailPackageObj !== null ? this.proInfo.emailPackageObj.priceSum : 0.00;  //邮件加油包金额
      let gjCurrencyPrice = this.proInfo.currencyPackageObj !== null ? this.proInfo.currencyPackageObj.priceSum : 0.00; //积点金额
      let sumFee = Number(amount) + Number(emailPrice) + Number(gjCurrencyPrice);
      return sumFee
    }
  },
  methods: {
    getPackageQuota() {
      getPackageQuota().then(res => {
        this.packageQuota = res;
        this.proInfo.emailResidue = res.remainingEmailNumber;
        this.proInfo.currencyResidue = res.remainingVirtualNumber;
      })
    },
    choosePackage(type) {
      if (this.curPackageType === type) {
        // 取消选择
        this.curPackageType = null;
        this.proInfo.fixedPackageObj = null;
      } else {
        // 切换选择
        this.curPackageType = type;
        this.proInfo.fixedPackageObj = this.proInfo.productPackages[type];
      }
      // this.sumFeeOrder();
    },
    pay() {
      if(this.totalAmount === 0 || (this.totalAmount??'') === ''){
        return this.$message.error("请选择固定订单套餐、邮件加油包或者工具加油包")
      }
      if (!this.checked) {
        return this.$message.error("请阅读《积加ERP产品服务协议》并点击同意");
      }
      this.proInfo.sumFee = this.totalAmount;
      this.step = 2;
    },
    queryData() {
      this.loading = true;
      this.proInfo.selfDefinesArr = [];
      this.proInfo.selfDefines = [];
      this.curPackageType = null
      queryProPackageData().then(response => {
        if (response.isSuccess) {
          let data = response.data;
          this.proInfo.residual = data.residual;
          this.proInfo.productPackages = data.displayProPackages ? data.displayProPackages.orderPackages : [];
          this.proInfo.emailPackages =  data.displayProPackages ? data.displayProPackages.emailPackages : [];
          this.proInfo.currencyPackages = data.displayProPackages ? data.displayProPackages.virtualPackages : [];
          //默认选中固定套餐
          // if (this.proInfo.productPackages.length > 0) {
          //     this.choosePackage(0);
          // }
       
        }
      }).complete(() => {
        this.loading = false;
      })
    },
    // sumFeeOrder() {
    //   var orderNumber1 = this.proInfo.customObj !== null ? this.proInfo.customObj.orderNumber : 0;
    //   var orderNumber2 = this.proInfo.fixedPackageObj !== null ? this.proInfo.fixedPackageObj.orderNumber : 0;   //固定套餐
    //   var residual = this.proInfo.residual !== null ? this.proInfo.residual : 0;
    //   this.proInfo.sumOrder = Number(orderNumber1) + Number(orderNumber2) + Number(residual);
    // },
    handleReturn(state) {
      this.step = 1;
      if (state) {
        this.queryData()
      }
    },

    openTemplateModal(item, state) {
      const modal = this.$gjCreate(ServiceAgreement, {
        on: {
          after: () => {
            modal.$gjDestroy();
          },
          agreed: () => {
            this.checked = true
          }
        }
      })
    },
     chooseMailPackage(type) {
      if (this.emailPackageType === type) {
        // 取消选择
        this.emailPackageType = null;
        this.proInfo.emailPackageObj = null;
      } else {
        // 切换选择
        this.emailPackageType = type;
        this.proInfo.emailPackageObj = this.proInfo.emailPackages[type];
      }
      // this.sumFeeOrder();
    },
     chooseCurrencyPackage(type) {
      if (this.currencyPackageType === type) {
        // 取消选择
        this.currencyPackageType = null;
        this.proInfo.currencyPackageObj = null;
      } else {
        // 切换选择
        this.currencyPackageType = type;
        this.proInfo.currencyPackageObj = this.proInfo.currencyPackages[type];
      }
      // this.sumFeeOrder();
    },
  }
}
</script>

<style lang="scss" scoped>
@import "common.scss";

.package-wrapper {
  width: 1160px;
  padding: 18px;
  min-height: 798px;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.15);
  position: relative;
  box-sizing: border-box;
}

.custom-package-bottom {
  position: absolute;
  left: 0;
  bottom: 10px;
  width: 100%;
  text-align: end;
  padding-right: 25px;

  .divider {
    margin-bottom: 10px;
  }
}

.divider-b {
  margin: 0 0 20px 0;
  /*background: none;*/
}

.product-package,
.package,
.custom-package {}

.product-package--balance {
  font-size: 12px;
  color: #333;
  margin-bottom: 10px;
}

.product-package--balance-number {
  font-size: 16px;
  color: rgba(0, 0, 0, 0.65);
  font-weight: 600;
  margin-right: 2px;
}

.custom-package--content,
.product-package--content {}

.custom-package--content-detail,
.product-package--content-detail {
  font-size: 12px;
  color: #888;
  margin-bottom: 6px;
}
//店铺下拉框css
.package-option-out{
  width: 300px;
  max-height: 300px;
  overflow-y: auto;
  padding: 8px 0;
  .package-option{
    height: auto;
    padding: 0;
    &:hover{
      background-color: #EDF7FF;
    }
    .package-option-item{
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 32px;
      padding: 6px 16px;
      box-sizing: border-box;
      font-size: 12px;
    }
    .zhekouIcon {
      width: 20px;
      height: 20px;
    }
    // 贯穿线
    .gj-font-throunghline{
        text-decoration: line-through;
    }
  }
}

.package-type {
  width: 225px;
  height: 300px;
  position: relative;
  background-image: url("../../../../assets/images/package/package_1.png");
  background-size: 100% 100%;
  cursor: pointer;
  box-sizing: border-box;
  margin: 10px 8px;
}

.package-choose--icon {
  position: absolute;
  top: 0;
  right: 20px;
}

.package-type:hover,
.package-type-choose {
  box-shadow: 0 4px 15px 0 rgba(0, 110, 255, 0.2);
}

.package-type-choose {
  height: 320px;
  position: relative;
  top: -10px;
  border-bottom: 5px solid #1f6eef;
  border-bottom-right-radius: 8px;
  border-bottom-left-radius: 8px;
}

.package-type--order {
  height: 90px;
  color: #fff;
  font-size: 22px;
  font-weight: bold;
}

.package-type--info {
  padding: 20px;
}

.package-type--price {
  margin: 4px 0 20px;
  color: #1f6eef;
  font-size: 16px;
}

.package-type--detail {
  display: flex;
  justify-content: space-between;
}

.package-type--detail--label,
.package-type--detail--content {
  margin-bottom: 10px;
}

.package-type--detail--label {
  font-size: 12px;
  color: #888888;
}

.package-type--detail--content {
  font-size: 12px;
  color: #444444;
}

.choose-package--detail {
  text-align: right;
}

.choose-package--detail--total {
  color: #444444;
  font-size: 14px;
}

.choose-package--detail--total-number {
  margin-left: 5px;
  font-size: 16px;
  font-weight: bold;
  color: $--price--color;
}

.choose-package--detail--order-total {
  margin: 10px 0 15px;
  font-size: 14px;
  color: #888888;
}

.choose-package--detail--order-total-number {
  margin: 0 5px;
  font-size: 25px;
  font-weight: bold;
  color: $--price--color;
}

.mailPackage {
  width: 220px;
  height: 116px;
  border: #e4e5e6 solid 1px;
  border-radius: 4px;
  background: #ffffff;
  text-align: center;
  margin: 10px 8px;
  cursor : pointer;
}
.mailPackage:hover {
  box-shadow: 0 4px 15px 0 rgba(0, 110, 255, 0.2);
}


.mail-type-choose {
  box-shadow: 0 4px 10px 0 rgba(0, 110, 255, 0.2);
}

.mail-type-choose {
  height: 110px;
  position: relative;
  top: -3px;
  border-bottom: 5px solid #1f6eef;
  border-bottom-right-radius: 8px;
  border-bottom-left-radius: 8px;
}

.discountLabel {
  position: absolute;
  top: 0;
  left: 0;
  padding-top: 2px;
  padding-bottom: 2px;
  padding-left: 8px;
  padding-right: 8px;
  border-radius: 4px 0px;
  color: #ffffff;
  font-size: 12px;
  text-align: center;
  line-height: 18px;
  align-content: center;
}
//首充样式
.active-type-firstcharge {
    background: linear-gradient(286.21deg, #ED6A0C 3.71%, #FAA466 95.74%);
}
//超值样式
.active-type-specialoffer {
    background: linear-gradient(95.76deg, #FF8970 5.87%, #EC0E00 92.46%);
}
//优惠价样式
.active-type-preferentialprice {
   background: linear-gradient(95.76deg, #5f9bff 5.87%, #1f6eef 92.46%);
}
//性价比最高样式
.active-type-costperformance {
   background: linear-gradient(95.76deg, #5f9bff 5.87%, #1f6eef 92.46%);
}
//无
.active-type-standard {

}
.number-of-packages {
  color: #333333;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
}

.concessional-rate {
  color: #1f6eef;
  font-weight: 500;
  font-size: 18px;
  line-height: 28px;
}
.unit-price {
  color: #666666;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  margin-left: 12px;
}
.original-price {
  color: #999999;
  font-weight: 400;
  font-size: 12px;
  line-height: 17px;
}
.original-price-list-price {
  margin-left: 4px;
}

.currencyPackage {
  background: #ffffff;
  width: 176px;
  height: 98px;
  border: #e4e5e6 solid 1px;
  border-radius: 4px;
  margin: 10px 6px;
  cursor : pointer;
  text-align: center;
}
.currencyPackage:hover {
  box-shadow: 0 4px 15px 0 rgba(0, 110, 255, 0.2);
}
.currency-type-choose {
  box-shadow: 0 4px 15px 0 rgba(0, 110, 255, 0.2);
}

.currency-type-choose {
  height: 90px;
  position: relative;
  top: -2px;
  border-bottom: 4px solid #1f6eef;
  border-bottom-right-radius: 8px;
  border-bottom-left-radius: 8px;
}
.currency-type-price {
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: #1F6EEF;
}

.currency-type-number {
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: #666666;
}

.currency-type-tips {
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: #ED6A0C;
}
.red-complimentary-quota {
  text-align: center;
  margin: 1px;
  font-size: 12px;
  line-height: 18px;
  color: #f53f3f;
}
</style>
